import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { SharedService } from '../../shared/shared.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastsManager } from 'ng2-toastr';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
//import { RoomComponent } from '../../dashboard/chat/room/room.component';
@Component({
    selector: 'app-panel-control',
    templateUrl: './panel-control.component.html',
    styleUrls: ['./panel-control.component.scss'],
    providers: [SharedService]
})
export class PanelControlComponent implements OnInit {

    public form: FormGroup;
    //selectEtiquetasId: number[];
    tags = [];
    public timeEHora: any;
    public timeEMinuto: any;
    public timeESegundo: any;
    public grabarVideollamadaCheck: boolean;

    public send_message: any;
    public checked1 : any;
    public checked2 : any;
    private enableVideocall:boolean = environment.enableVideocall;

    constructor(
        private fb: FormBuilder,
        private sharedService: SharedService,
        private spinner: NgxSpinnerService,
        public _router: Router,
        public toastr: ToastsManager,
        
        //public roomControler: RoomComponent
    ) {
        this.form = this.fb.group({
            countRooms: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(4)]],
            //selectEtiquetasId:[''],
            timeEsperaHora: [''],
            timeEsperaMinuto: ['', [Validators.required]],
            timeEsperaSegundo: [''],
            timeInactividadHora: [''],
            timeInactividadMinuto: ['', [Validators.required]],
            timeInactividadSegundo: [''],
            timeCierreHora: [''],
            timeCierreMinuto: ['', [Validators.required]],
            timeCierreSegundo: [''],
            timeCierre: [''],
            msjInactividad: ['', [Validators.required]],
            msjCierre: ['', [Validators.required]],
            msjSalidaCola: ['', [Validators.required]],
            checkPromedio: [''],
            checkPosicion: [''],
            msjContactar:[''],
            grabarVideollamada: [false],
            msjGrabarVideollamada: ['',[Validators.required]],
        });

        this.checked1 = false;
        this.checked2 = false;

        this.getInfo();
    }

    addCustomUser = (term) => ({ id: term, name: term });

    private getInfo() {
        this.spinner.show();
        let data = {
            auth_token: this.sharedService.getCookie("auth_token")
        }
        this.sharedService.getInfoPanel(data).subscribe(
            data => {
                this.spinner.hide();
                this.timeEHora = data.message.timeEsperaHora;
                this.timeEMinuto = data.message.timeEsperaMinuto;
                this.timeESegundo = data.message.timeEsperaSegundo;
                this.form.get('countRooms').patchValue(data.message.qty_rooms);
                this.form.get('timeEsperaHora').patchValue(data.message.timeEsperaHora);
                this.form.get('timeEsperaMinuto').patchValue(data.message.timeEsperaMinuto);
                this.form.get('timeEsperaSegundo').patchValue(data.message.timeEsperaSegundo);
                this.form.get('timeInactividadHora').patchValue(data.message.timeInactividadHora);
                this.form.get('timeInactividadMinuto').patchValue(data.message.timeInactividadMinuto);
                this.form.get('timeInactividadSegundo').patchValue(data.message.timeInactividadSegundo);
                this.form.get('timeCierreHora').patchValue(data.message.timeCierreHora);
                this.form.get('timeCierreMinuto').patchValue(data.message.timeCierreMinuto);
                this.form.get('timeCierreSegundo').patchValue(data.message.timeCierreSegundo);
                this.form.get('msjInactividad').patchValue(data.message.message_inactivity);
                this.form.get('msjCierre').patchValue(data.message.message_closing);
                this.form.get('checkPosicion').patchValue(data.message.position);
                this.form.get('checkPromedio').patchValue(data.message.average_time);
                this.form.get('msjSalidaCola').patchValue(data.message.message_exit_pending);
                this.form.get('msjContactar').patchValue(data.message.message_contacted);
                this.form.get('grabarVideollamada').patchValue(data.message.videocallRecording);
                this.form.get('msjGrabarVideollamada').patchValue(data.message.messageRecording);

                if(data.message.contacted == '1') {
                    this.send_message = false;
                    this.checked1 = true;
                } else {
                    this.send_message = true;
                    this.checked2 = true;
                }

            }, error => {
                console.log("Ocurrió un error al consultar la información", error);
                this.toastr.error("Ocurrió un error al consultar la información", "Error");
                this.spinner.hide();
            }

        );
    }

    ngOnInit() {
        
    }

    validateFormat(event) {
        let key;
        if (event.type === 'paste') {
            key = event.clipboardData.getData('text/plain');
        } else {
            key = event.keyCode;
            key = String.fromCharCode(key);
        }
        const regex = /[0-9]|\./;
        if (!regex.test(key)) {
            event.returnValue = false;
            if (event.preventDefault) {
                event.preventDefault();
            }
        }
    }

    guardar() {
        if (this.send_message && !this.form.value.msjContactar) {
            this.toastr.error("Agregar un mensaje cuando el agente no se encuentra disponible", 'Error');
            return;
        }

        if(this.send_message) {
            this.form.value.contacted = '2';
        } else {
            this.form.value.contacted = '1';
            this.form.value.msjContactar = '';
        }

        var hora2 = ("00" + this.form.value.timeInactividadHora).slice(-2) + ':' + ("00" + this.form.value.timeInactividadMinuto).slice(-2) + ':' + ("00" + this.form.value.timeInactividadSegundo).slice(-2);
        var hora1 = ("00" + this.form.value.timeCierreHora).slice(-2) + ':' + ("00" + this.form.value.timeCierreMinuto).slice(-2) + ':' + ("00" + this.form.value.timeCierreSegundo).slice(-2);

        if (hora1 < hora2) {
            this.toastr.error("Tiempo de cierre por inactividad no puede ser menor a tiempo notificación de inactividad", 'Error');
        } else {
            this.spinner.show();
            this.form.value.auth_token = this.sharedService.getCookie('auth_token');
            this.form.value.countRooms = parseInt(this.form.value.countRooms);
            
            this.sharedService.guardarInfoPanel(this.form.value).subscribe(
                data => {
                    console.log(data.status);
                    if (data.status) {
                        this.getInfo();
                        this.toastr.success('Guardado con éxito!', '¡Éxito!');
                        
                    } else {
                        this.toastr.error(data.message, 'Error');
                    }
                    //this.load = false;
                    this.spinner.hide();
                },
                error => {
                    this.spinner.hide();
                }
            );
        }
    }
    

    

    changeContactados(valor) {
        if ('2' == valor) {
            this.checked1 = false;
            this.checked2 = true;
            this.send_message = true;
        } else {
            this.checked2 = false;
            this.checked1 = true;
            this.send_message = false;
        }
    }



}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/panel-control/panel-control.component.ts